import { useEffect, useMemo, useState } from "react";

import useAxios from "@hooks/use-axios";
import { BRANDS_DEFAULT_LIMIT, BRANDS_ENDPOINT } from "../misc/constants";
import { defaultBrandFilters, toBrandFilterParams } from "../misc/schema";

const useBrands = () => {
    const { axiosInstance, loading } = useAxios({ base: "ops", initialLoader: true });

    const [rows, setRows] = useState([]);
    const [pagination, setPagination] = useState({ total: 0, page: 1, limit: BRANDS_DEFAULT_LIMIT });
    const [filters, setFilters] = useState(defaultBrandFilters);
    const [filterOpen, setFilterOpen] = useState(false);

    const fetchBrands = async (page = 1, limit = BRANDS_DEFAULT_LIMIT, currentFilters = filters) => {
        const params = await toBrandFilterParams(currentFilters);
        const res = await axiosInstance.get(BRANDS_ENDPOINT, {
            params: { page, limit, ...params }
        });
        const result = res.data || res;

        setRows(result.data || result.items || result.results || []);
        setPagination({
            total: result.pagination?.total ?? result.total ?? 0,
            page : result.pagination?.page ?? page,
            limit: result.pagination?.limit ?? limit
        });
    };
    useEffect(() => {
        fetchBrands(1, pagination.limit, filters);
    }, [filters]); // eslint-disable-line react-hooks/exhaustive-deps

    const activeFilterCount = useMemo(() => (
        Object.keys(defaultBrandFilters).filter((key) => filters[key]).length
    ), [filters]);

    const handlePageChange = (limit, page) => {
        fetchBrands(page, limit, filters);
    };

    const handlePerRowsChange = (limit) => {
        fetchBrands(1, limit, filters);
    };

    const handleFilterChange = (nextFilters) => {
        // setFilters alone is enough — the [filters] effect above re-fetches with the
        // merged value; calling fetchBrands here too just fired the same request twice.
        setFilters((prev) => ({ ...prev, ...nextFilters }));
    };

    const openFilters = () => setFilterOpen(true);

    const closeFilters = () => setFilterOpen(false);

    return {
        rows,
        pagination,
        loading,
        filters,
        activeFilterCount,
        filterOpen,
        openFilters,
        closeFilters,
        handleFilterChange,
        handlePageChange,
        handlePerRowsChange
    };
};

export default useBrands;
